import { render, staticRenderFns } from "./LegacyDocuments.vue?vue&type=template&id=c53e33ee&scoped=true&"
import script from "./LegacyDocuments.vue?vue&type=script&lang=js&"
export * from "./LegacyDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53e33ee",
  null
  
)

export default component.exports